/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBLANGUAGE = {
    Englishireland: '6153',
    Spanish: '10',
    Swedish: '4',
    French: '12',
    VoluntaryLoadingExtraPremium: '1',
    EnglishUs: '1033',
    Afrikaans: '13',
    None: '0',
    Norwegian: '1044',
    VoluntaryExclusionNoExtraPremium: '2',
    German: '8',
    Flemish: '7'
} as const;
export type GHUBLANGUAGE = typeof GHUBLANGUAGE[keyof typeof GHUBLANGUAGE];


export function GHUBLANGUAGEFromJSON(json: any): GHUBLANGUAGE {
    return GHUBLANGUAGEFromJSONTyped(json, false);
}

export function GHUBLANGUAGEFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBLANGUAGE {
    return json as GHUBLANGUAGE;
}

export function GHUBLANGUAGEToJSON(value?: GHUBLANGUAGE | null): any {
    return value as any;
}

